import { types, Instance } from 'mobx-state-tree';
const { model, string, number, identifierNumber, boolean, maybeNull } = types;

export const ClientModel = model('NewClientModel', {
  id: identifierNumber,
  name: string,
  lastName: string,
  email: string,
  organizationName: maybeNull(string),
  organizationDomain: maybeNull(string),
  organizationFullDomain: maybeNull(string),
  AuthTokenUrl: string,
  password: string,
  phone: string,
  numberOfUserAccountsId: number,
  loginToken: string,
  registerStatus: number,
  registerStatusName: string,
  serviceStatus: number,
  serviceStatusName: string,
  dateRegistration: string,
  renewalDate: string,
  clientNumberOfUserAccountName: string,
  periodName: string,
  ldapStatus: boolean,
  es2Status: boolean,
  subscriptionPlanId: number,
  appVersion: string,
});

export type IClientModel = Instance<typeof ClientModel>;
